<template>
  <div style="display:none;">
    <div id="printMe">
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="margin-left:5mm;"
      >
        <div v-if="product.distinguish != 'distinguish'">
          <table style="widht : 60mm;">
            <tr style="widht : 60mm;">
              <td rowspan="4" style="padding-right: 2mm;">
                <qrcode-vue :value="product.url" :size="QrCodeSize" level="H" :renderAs="renderAs"></qrcode-vue>
              </td>

              <td style="widht : 60mm; ">
                <tr>
                  <td style=" margin:0px;">
                    <p class="titleBold" style="font-size: 35px; margin:0px; line-height:35px;">正品</p>
                  </td>
                </tr>

                <tr>
                  <td style>
                    <p
                      class="subTitleBold"
                      style="font-size: 12px; padding:0px; margin:0px; line-height:10px;"
                    >Genuine Royalty</p>
                  </td>
                </tr>

                <tr>
                  <td style>
                    <p
                      style="font-size: 11px; padding:0px; margin:0px; line-height:10px;"
                    >Serial Number</p>
                  </td>
                </tr>
              </td>
            </tr>
          </table>

          <table style="widht : 60mm">
            <tr style="widht : 60mm">
              <td style="padding:0px; margin:0px;">
                <p style="font-size: 12px; padding:0px; margin:0px;" class="subTitleBold">정품을 인증합니다</p>
              </td>
            </tr>
            <tr style="widht : 60mm">
              <td style="padding:0px; margin:0px;">
                <p
                  style="font-size: 12px; padding:0px; margin:0px; padding-left:2mm; padding-right:2mm; width : 40mm; text-align:center;"
                  class="backGroundColorBlack"
                >{{product.authCode}}</p>
              </td>
            </tr>
            <tr style="widht : 60mm">
              <td style="font-size: 12px; padding:0px; margin:0px;" v-html="descriptionContent"></td>
            </tr>
          </table>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; width : 55mm; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm;"
            >인쇄매수 : {{product.variantPrintCount}} ▼</p>
            <div style="width : 52mm;">
              <p
                style="margin:0px; padding:0px; width : 55mm; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 11px; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >{{product.productName}}</p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
              >옵션 : {{product.variantName}}</p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px;"
              >상품코드 : {{product.productCode}}</p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 11px;"
              >품목코드 : {{product.variantCode}}</p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/RolLabel.css"]
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "http://m." + store.state.mallId + ".cafe24.com",
      QrCodeSize: 68,
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      descriptionContent:
        "<font style='text-align:center;'>QR 코드를 스캔해주세요</font>"
    };
  },
  components: {
    QrcodeVue
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      let idx = 0;
      this.productInfos = [];
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name,
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0
          };

          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (
              var j = 0;
              j < data[productCode][variantCode][i][0].print_count;
              j++
            ) {
              data[productCode][variantCode][i][0].product_name;
              let serialNumber =
                data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(
                data[productCode][variantCode][i][0].serial_number
              );
              let QrData = {
                id: this.listCount,
                url:
                  "http://m." +
                  store.state.mallId +
                  ".cafe24.com/royalty.html?authQrCode=" +
                  encrySerialNumber,
                authCode: serialNumber
              };
              this.productInfos.push(QrData);
              this.listCount++;
              if (!this.productInfos[idx].variantPrintCount) {
                this.productInfos[idx].variantPrintCount = 0;
              }
              distinguishData["variantPrintCount"]++;
            }
          }
          this.productInfos.push(distinguishData);
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {
      try {
        let data = await M.api(M.entry("/get/print"), {});

        //문구 설정 체크
        if (data.print_description) {
          this.descriptionContent =
            "<p class='subTitle' style='margin-top: 3mm;'>" +
            data.print_description +
            "</p>";
          //이미지 설정 체크
        } else if (localStorage.imageUrlInfo) {
          this.descriptionContent =
            "<img src=" + localStorage.imageUrlInfo + ">";
          //default
        } else {
          this.descriptionContent =
            "<p class='subTitle' style='margin-top: 3mm;'>QR 코드를 스캔해주세요</p>";
        }
      } catch (e) {
        //console.log(e);
      }
    }
  },

  created: async function() {
    /**
     * QR 코드 설정 데이터 가져오기
     */
    await this.getQrcodeSettingInfo();
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  }
};
</script>